import { IFormProps } from "@klantondersteuning/shared";
import * as React from "react";

const StopzettenBroninhoudingPageWrapper = React.lazy(
  () => import("@klantondersteuning/shared/src/page/FormulierPage")
);

export function FormulierPage(props: Readonly<IFormProps>) {
  return (
    <React.Suspense
      fallback={
        <div className="pilet-loader" role="status">
          Loading...
        </div>
      }
    >
      <StopzettenBroninhoudingPageWrapper {...props} />
    </React.Suspense>
  );
}
